<template>
    <div>
        <div id="notify-root">
            <div class="notification notification_type_error" v-if="msg" :style="skin.header_desktop.servicios">
                <div class="notification__wrapper">
                    <div>
                        <svg v-if="status === 'success'" style="width: 1.25rem; margin-top: 1rem; margin-left: 1rem"
                            fill="#49ca5f" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 335.765 335.765"
                            xml:space="preserve" stroke="#49ca5f">
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <g>
                                    <g>
                                        <polygon
                                            points="311.757,41.803 107.573,245.96 23.986,162.364 0,186.393 107.573,293.962 335.765,65.795 ">
                                        </polygon>
                                    </g>
                                </g>
                            </g>
                        </svg>
                        <svg v-else style="width: 1.25rem; margin-top: 1rem; margin-left: 1rem" viewBox="0 0 20 20"
                            fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M16.9985 14.4733L14.4718 17L10 12.5267L5.52672 16.9985L3 14.4718L7.47474 10L3.00146 5.52672L5.52818 3.00146L10 7.47328L14.4733 3L17 5.52672L12.5253 10L16.9985 14.4733Z"
                                fill="#D31C32"></path>
                        </svg>
                    </div>
                    <span class="notification__text">{{ msg }}</span>
                    <span class="sign-in-desktop__cross1" @click="clearNotificacion">
                        <svg style="width: 100%;height: 100%;" viewBox="0 0 43 43" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M26.3137 15L28.0108 16.6971L23.3538 21.354L28.3137 26.3139L26.6167 28.011L21.6567 23.0511L16.6971 28.0108L15 26.3137L19.9597 21.354L15.3029 16.6973L17 15.0002L21.6567 19.657L26.3137 15Z"
                                fill="#9583A0"></path>
                        </svg>
                    </span>
                </div>
            </div>
        </div>
        <login v-if="showLogin" v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation"
            @close="ocultarLogin()" />
        <div class="mb-1" id="mainHeader">
            <nav class="navbar navbar-expand-lg scrolling-navbar double-nav py-1 pr-2 px-lg-0 px-xl-3 py-3"
                :style="skin.header_desktop.nav_bar">
                <div class="container-fluid my-0 ganamos-header__layout">
                    <div v-if="hasLateralMenu" class="ganamos-header__menu-toggle me-3 d-flex align-items-center" @click="toggleLateralMenu" style="cursor:pointer">
                        <i v-if="!lateralMenuOpen" class="fas fa-bars"
                            :style="{ fontSize: desktopActionIconSize('1.3rem'), color: '#ccc' }"></i>
                        <i v-else class="fas fa-times"
                            :style="{ fontSize: desktopActionIconSize('1.3rem'), color: '#ccc' }"></i>
                    </div>
                    <div class="ganamos-header__logo float-left" @click="change_view(skin.lobby ? 'main' : 'lobby')" style="cursor:pointer">
                        <img v-if="skin.header_desktop.logo != ''" :src="skin.header_desktop.logo"
                            :width="skin.header_desktop.logo_width" alt=""
                            :style="hasLateralMenu ? skin.lateral_menu.logo_dimensions : 'max-width: 200px; max-height: 45px;'">
                    </div>
                    <div ref="menuContainer" class="ganamos-header__navigation" id="navbarText">
                        <div ref="menuList" class="ganamos-header__navigation-list d-flex">
                            <div v-for="item in visibleMenuCategories" :key="item.category" ref="menuItem" ref-in-for
                                @click="change_view(item.category)" style="cursor:pointer;" class="ganamos-header__navigation-item text-center"
                                :class="{ 'ganamos-header__navigation-item--gamanza': isGamanzaMenuCategory(item.category) }">
                                <div class="p-2" style="cursor:pointer;white-space: nowrap;"
                                    :style="skin.header_desktop.nav_bar_text + getNavBarStyle(item.category)">
                                    {{ menuLabel(item) }}
                                </div>
                            </div>
                            <div v-if="overflowMenuCategories.length" ref="menuOverflow" class="ganamos-header__navigation-overflow dropdown">
                                <button type="button" class="ganamos-header__navigation-overflow-toggle p-2"
                                    :class="{ active: hasActiveOverflowCategory }" :aria-expanded="String(overflowMenuOpen)"
                                    @click="toggleOverflowMenu" aria-label="Mostrar más opciones de navegación"
                                    :style="skin.header_desktop.nav_bar_text + (hasActiveOverflowCategory ? (skin.header_desktop.selection1 ?? 'color: white !important') : '')">
                                    <i class="fas fa-ellipsis-h"></i>
                                    <i class="fas fa-chevron-down ganamos-header__navigation-overflow-chevron"></i>
                                </button>
                                <div class="dropdown-menu dropdown-menu-end ganamos-header__navigation-overflow-menu"
                                    :class="{ show: overflowMenuOpen }"
                                    :style="skin.header_desktop.servicios + skin.header_desktop.nav_bar_text">
                                    <button v-for="item in overflowMenuCategories" :key="item.category" type="button"
                                        class="dropdown-item ganamos-header__navigation-overflow-item"
                                        :class="{ 'ganamos-header__navigation-overflow-item--gamanza': isGamanzaMenuCategory(item.category) }"
                                        :style="skin.header_desktop.nav_bar_text + getNavBarStyle(item.category)"
                                        @click="selectOverflowCategory(item.category)">
                                        {{ menuLabel(item) }}
                                    </button>
                                </div>
                            </div>
                            <div v-if="skin.customActionButton.enabled" ref="menuFixedAction" @click="user.token != '' ? action() : login()"
                                style="cursor:pointer;display:table;" class="ganamos-header__navigation-action px-3 pe-3 text-center">
                                <span
                                    :style="skin.header_desktop.nav_bar_text + (actualRoute === '' ? (skin.header_desktop.selection1 ?? 'color: white !important') : '')"
                                    style="display:table-cell;vertical-align:middle;"><i
                                        class="fa fa-external-link fa-fw"></i></span>
                            </div>
                        </div>
                    </div>
                    <div class="ganamos-header__actions d-flex">
                        <div v-if="hasLateralMenu" class="ganamos-header__support float btn" @click="openSupportModalJivo()">
                            <img id="icon_jivo" class="" src="../../../assets/images/icon_jivo.png" alt="" width="45px">
                        </div>
                        <div v-if="user.token != ''" class="ganamos-header__balance px-2 pe-2 text-center" style="display:table;">
                            <div v-if="skin.header_desktop.balance" class="nav-item"
                                :class="skin.my_account.myaccount_type == 'JM' ? '' : 'text-end'"
                                style="width:33%;display:table-cell;vertical-align:middle;font-size: 15px;">
                                <div style="overflow: hidden;border-radius: 6.25rem;" class="text-center"
                                    :style="skin.header_desktop.login_btn">
                                    <div
                                        @click="openBalanceGateway"
                                        style="border-radius: 6.25rem; cursor: pointer;"
                                        class="p-2 d-flex"
                                        :style="skin.header_desktop.nav_bar_text + skin.my_account.content_background">
                                        <span>
                                            <svg style="width: 1.5rem;height: 1.5rem;" viewBox="0 0 27 28" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_10423_34573)">
                                                    <path
                                                        d="M20.7652 5.5C21.3542 5.5 21.919 5.73396 22.3355 6.15041C22.7519 6.56687 22.9859 7.1317 22.9859 7.72065V10.2389C23.3234 10.4338 23.6038 10.7141 23.7987 11.0517C23.9936 11.3892 24.0962 11.7722 24.0962 12.162V16.6033C24.0962 16.9931 23.9936 17.376 23.7987 17.7136C23.6038 18.0511 23.3234 18.3314 22.9859 18.5263V21.0446C22.9859 21.6335 22.7519 22.1983 22.3355 22.6148C21.919 23.0313 21.3542 23.2652 20.7652 23.2652H5.22065C4.6317 23.2652 4.06687 23.0313 3.65041 22.6148C3.23396 22.1983 3 21.6335 3 21.0446V7.72065C3 7.1317 3.23396 6.56687 3.65041 6.15041C4.06687 5.73396 4.6317 5.5 5.22065 5.5H20.7652ZM20.7652 7.72065H5.22065V21.0446H20.7652V18.8239H16.3239C15.1652 18.8239 14.0524 18.3711 13.2229 17.5621C12.3934 16.7531 11.9129 15.652 11.8839 14.4937C11.855 13.3354 12.2798 12.2116 13.0678 11.3621C13.8558 10.5126 14.9446 10.0048 16.1018 9.94686L16.3239 9.9413H20.7652V7.72065ZM21.8755 12.162H16.3239C15.735 12.162 15.1701 12.3959 14.7537 12.8124C14.3372 13.2288 14.1033 13.7937 14.1033 14.3826C14.1033 14.9716 14.3372 15.5364 14.7537 15.9528C15.1701 16.3693 15.735 16.6033 16.3239 16.6033H21.8755V12.162ZM17.4342 13.2723C17.7287 13.2723 18.0111 13.3893 18.2194 13.5975C18.4276 13.8057 18.5446 14.0881 18.5446 14.3826C18.5446 14.6771 18.4276 14.9595 18.2194 15.1677C18.0111 15.376 17.7287 15.4929 17.4342 15.4929C17.1398 15.4929 16.8573 15.376 16.6491 15.1677C16.4409 14.9595 16.3239 14.6771 16.3239 14.3826C16.3239 14.0881 16.4409 13.8057 16.6491 13.5975C16.8573 13.3893 17.1398 13.2723 17.4342 13.2723Z"
                                                        fill="#9583A0">
                                                    </path>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_10423_34573">
                                                        <rect width="21" height="18" fill="white"
                                                            transform="translate(3 5.5)">
                                                        </rect>
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </span>
                                        <span class="mx-2">{{ user.user_data.data ? new
                                            Intl.NumberFormat("de-DE", {
                                                minimumFractionDigits:
                                                    skin.qBet_config.decimalsQty, maximumFractionDigits:
                                                    skin.qBet_config.decimalsQty
                                            }).format(balance.saldo) : 0 }}</span>
                                        <span :style="skin.header_desktop.nav_bar_text" class="mx-2">{{
                                            user.user_data?.data?.currency
                                        }}</span>
                                    </div>
                                </div>
                                <!-- <i @click="showBalanceAction" class="fas fa-coins pr-0 mx-2"></i>
                          <span v-if="showBalance">{{ user.user_data.data ? new Intl.NumberFormat("de-DE",{minimumFractionDigits: skin.qBet_config.decimalsQty,maximumFractionDigits: skin.qBet_config.decimalsQty}).format(balance.saldo) : 0 }}</span> -->
                            </div>
                        </div>
                        <div v-if="user?.token == '' && skin?.register" class="ganamos-header__auth-action" style="display: flex;align-items: center;">
                            <div style="cursor:pointer;overflow: hidden;border-radius: 6.25rem;" class="text-center"
                                :style="skin.header_desktop.login_btn + skin.header_desktop?.border_register">
                                <div class="ganamos-header__register-button p-2" @click="register"
                                    style="cursor:pointer;min-width: 120px;border-radius: 6.25rem;"
                                    :style="skin.header_desktop.nav_bar_text + skin.header_desktop.register_btn">
                                    <span v-if="hasLateralMenu">Registrate</span>
                                    <span v-else>{{ translate("sign_in") }}</span>
                                </div>
                            </div>
                        </div>
                        <div v-if="user.token == '' && skin.login" class="ganamos-header__auth-action"
                            style="display: flex;justify-content: flex-end;align-items: center;">
                            <div style="cursor:pointer;overflow: hidden;border-radius: 6.25rem;" class="text-center">
                                <div class="ganamos-header__login-button p-2" @click="login"
                                    style="cursor:pointer;min-width: 100px;border-radius: 6.25rem;"
                                    :style="skin.header_desktop.nav_bar_text + skin.my_account.content_background">
                                    <span v-if="hasLateralMenu">Ingresar</span>
                                    <span v-else>{{ translate("log_in") }}</span>
                                </div>
                            </div>
                            <div v-if="!skin.languageSelector" class="header-desktop__separator"></div>
                            <div v-if="!skin.languageSelector">
                                <languageSelector :skin="skin" :language="language" :movil="movil">
                                </languageSelector>
                            </div>
                        </div>
                        
                        <div v-if="user.token != ''" class="ganamos-header__user-actions py-1 me-2 pb-1 px-2 pe-2 text-center nav-item"
                            style="display: flex;gap:6px;align-items: center;">

                            <gamanza-account-dropdown
                                v-if="showGamanzaProfileDropdown"
                                :skin="skin"
                                :language="language"
                                :user="user"
                                :balance="balance.saldo"
                                :bonus="bonus"
                                :frozen="frozen"
                                :show-standard-bonus-balances="showStandardBonusBalances"
                                @open-account="openAccountModal"
                                @open-balance-history="openAccountModal"
                                @open-change-password="openAccountModal"
                                @navigate-gamanza-page="change_view"
                            />
                            <div v-else style="cursor:pointer;display: flex;align-items: center;"
                                class="py-1 pb-1 text-center nav-item dropdown dropstart">
                                <div style="cursor:pointer;overflow: hidden;border-radius: 50%;display:flex;align-items:center;"
                                    class="text-center" :style="skin.header_desktop.login_btn" id="userMenuDropdown"
                                    role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    <div class="p-2" style="cursor:pointer;border-radius: 50%;"
                                        :style="skin.header_desktop.nav_bar_text + skin.my_account.content_background">
                                        <svg :style="{ width: desktopActionIconSize('1.3rem'), height: desktopActionIconSize('1.3rem') }" viewBox="0 0 28 28" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path opacity="0.927" fill-rule="evenodd" clip-rule="evenodd"
                                                d="M12.9135 3.03401C15.0685 2.82516 16.7883 3.57826 18.0732 5.29327C19.2707 7.30272 19.2503 9.29735 18.0121 11.2773C16.2174 13.4382 14.009 13.998 11.387 12.9564C9.1058 11.6401 8.17969 9.67599 8.6087 7.06404C9.06434 5.32624 10.1126 4.09488 11.7533 3.36984C12.1402 3.23005 12.5269 3.1181 12.9135 3.03401ZM13.1578 4.01098C15.535 3.92135 17.0921 5.00011 17.8289 7.24722C18.1823 9.29814 17.4801 10.8756 15.7223 11.9795C13.93 12.8051 12.2813 12.5812 10.7764 11.3078C9.3153 9.68283 9.10159 7.90186 10.1352 5.96494C10.8817 4.90504 11.8892 4.25376 13.1578 4.01098Z"
                                                fill="currentColor" stroke="currentColor" stroke-width="1.04211"></path>
                                            <path opacity="0.941" fill-rule="evenodd" clip-rule="evenodd"
                                                d="M8.63947 15.6562C12.0386 15.646 15.4376 15.6562 18.8367 15.6867C20.6071 15.9309 21.8792 16.857 22.653 18.465C23.4354 20.6559 22.9571 22.5182 21.2181 24.0521C20.6491 24.466 20.0181 24.7509 19.3252 24.9069C15.7446 25.007 12.1623 25.0273 8.57841 24.968C6.28838 24.5505 4.93484 23.197 4.51785 20.9074C4.35399 18.68 5.25974 17.0619 7.23507 16.0531C7.69736 15.8716 8.16552 15.7393 8.63947 15.6562ZM8.94478 16.6331C12.1404 16.6229 15.3359 16.6331 18.5314 16.6637C20.6885 16.9584 21.8487 18.1898 22.0119 20.3579C21.8942 22.2513 20.9172 23.442 19.0809 23.9299C15.6834 24.0297 12.2843 24.05 8.88372 23.991C7.12241 23.7358 6.01312 22.7487 5.55589 21.0295C5.32764 19.1013 6.09091 17.7274 7.84568 16.9079C8.21076 16.776 8.57713 16.6844 8.94478 16.6331Z"
                                                fill="currentColor" stroke="currentColor" stroke-width="1.04211"></path>
                                        </svg>
                                    </div>
                                </div>
                                <div :style="skin.header_desktop.servicios + skin.header_desktop.nav_bar_text"
                                    class="dropdown-menu" aria-labelledby="userMenuDropdown" style="min-width: 250px;">
                                    <div class="d-flex justify-content-end px-2 pt-1">
                                        <button type="button" class="btn p-0" aria-label="Cerrar menú de usuario"
                                            :style="skin.header_desktop.nav_bar_text" @click.stop="closeUserMenu">
                                            <i class="fas fa-times" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                    <div class="px-2 pe-2 mb-3">
                                        <span class="user-name">ID: {{ user.user_data.data ? user.user_data.data.user_id
                                            :
                                            ''
                                            }}</span><br>
                                        <span>{{ user.user_data.data ? user.user_data.data.user_name : '' }}</span>
                                        <div class="d-flex">
                                            <div style="width: 40%;">
                                                <span>{{ translate('balance2') }}:</span>
                                            </div>
                                            <div style="width: 60%;" class="text-end">
                                                <span style="color: yellow;width: 100%;">{{ user.user_data.data ? new
                                                    Intl.NumberFormat("de-DE", {
                                                        minimumFractionDigits:
                                                            skin.qBet_config.decimalsQty, maximumFractionDigits:
                                                            skin.qBet_config.decimalsQty
                                                    }).format(balance.saldo) : 0 }}</span>
                                            </div>
                                        </div>
                                        <div v-if="showStandardBonusBalances" class="d-flex">
                                            <div style="width: 40%;">
                                                <span>{{ translate('bonus_balance') }}:</span>
                                            </div>
                                            <div style="width: 60%;" class="text-end">
                                                <span style="color: yellow;width: 100%;">{{ user.user_data.data ? new
                                                    Intl.NumberFormat("de-DE", {
                                                        minimumFractionDigits:
                                                            skin.qBet_config.decimalsQty, maximumFractionDigits:
                                                            skin.qBet_config.decimalsQty
                                                    }).format(bonus) : 0 }}</span>
                                            </div>
                                        </div>
                                        <div v-if="skin.bonos" class="d-flex">
                                            <div style="width: 40%;">
                                                <span>Saldo bono de casino:</span>
                                            </div>
                                            <div style="width: 60%;" class="text-end">
                                                <span style="color: yellow;width: 100%;">{{ new
                                                    Intl.NumberFormat("de-DE", {
                                                        minimumFractionDigits:
                                                            skin.qBet_config.decimalsQty, maximumFractionDigits:
                                                            skin.qBet_config.decimalsQty
                                                    }).format(casinoBonusBalance) }}</span>
                                            </div>
                                        </div>
                                        <div v-if="skin.bonos" class="d-flex">
                                            <div style="width: 40%;">
                                                <span>Saldo bono de deportivas:</span>
                                            </div>
                                            <div style="width: 60%;" class="text-end">
                                                <span style="color: yellow;width: 100%;">{{ new
                                                    Intl.NumberFormat("de-DE", {
                                                        minimumFractionDigits:
                                                            skin.qBet_config.decimalsQty, maximumFractionDigits:
                                                            skin.qBet_config.decimalsQty
                                                    }).format(sportsbookBonusBalance) }}</span>
                                            </div>
                                        </div>
                                        <div v-if="showStandardBonusBalances" class="d-flex">
                                            <div style="width: 40%;">
                                                <span>{{ translate('frozen_balance') }}:</span>
                                            </div>
                                            <div style="width: 60%;" class="text-end">
                                                <span style="color: yellow;width: 100%;">{{ user.user_data.data ? new
                                                    Intl.NumberFormat("de-DE", {
                                                        minimumFractionDigits:
                                                            skin.qBet_config.decimalsQty, maximumFractionDigits:
                                                            skin.qBet_config.decimalsQty
                                                    }).format(frozen) : 0 }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="px-2 pe-2 mb-3" data-bs-toggle="modal" data-bs-target="#myAccountJm">
                                        <div class="d-flex">
                                            <div style="width: 15%;" class="me-2">
                                                <svg class="SVGInline-svg SVG-component__content-svg"
                                                    viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM6.023 15.416C7.491 17.606 9.695 19 12.16 19C14.624 19 16.829 17.607 18.296 15.416C16.6317 13.8606 14.4379 12.9968 12.16 13C9.88171 12.9966 7.68751 13.8604 6.023 15.416ZM12 11C12.7956 11 13.5587 10.6839 14.1213 10.1213C14.6839 9.55871 15 8.79565 15 8C15 7.20435 14.6839 6.44129 14.1213 5.87868C13.5587 5.31607 12.7956 5 12 5C11.2044 5 10.4413 5.31607 9.87868 5.87868C9.31607 6.44129 9 7.20435 9 8C9 8.79565 9.31607 9.55871 9.87868 10.1213C10.4413 10.6839 11.2044 11 12 11Z"
                                                        fill="#EDEDED"></path>
                                                </svg>
                                            </div>
                                            <div style="width: 85%; text-transform: lowercase;" class="py-1">
                                                <span style="color:#ccc;">{{ translate('my_account') }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="px-2 pe-2 mb-3" data-bs-toggle="modal" data-bs-target="#myAccountJm">
                                        <div class="d-flex">
                                            <div style="width: 15%;" class="me-2">
                                                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                                        d="M10.0667 15.5661C10.5413 15.5661 10.926 15.1814 10.926 14.7067V14.1789C13.6199 13.1817 12.9694 9.21888 10.0667 9.16393C8.92406 9.11731 8.9296 7.49855 10.0667 7.45137C10.4117 7.45137 10.6872 7.63415 10.8225 7.95293C11.0079 8.38978 11.5125 8.59353 11.9494 8.40813C12.3862 8.22268 12.59 7.71815 12.4046 7.28126C12.1169 6.60362 11.5824 6.10807 10.926 5.87729V5.2968C10.8807 4.15661 9.25233 4.15747 9.20734 5.2968V5.87987C6.51731 6.87702 7.15886 10.8275 10.0667 10.8826C11.2029 10.9296 11.2101 12.5601 10.0667 12.6074C9.73249 12.6074 9.40104 12.3894 9.26071 12.0771C9.06615 11.6442 8.55746 11.451 8.1246 11.6456C7.6917 11.8402 7.49848 12.3488 7.69308 12.7817C7.98638 13.4343 8.54848 13.9356 9.20734 14.1736V14.7067C9.20734 15.1814 9.59207 15.5661 10.0667 15.5661ZM7.10176 18.5083C7.4473 18.5083 7.77321 18.2983 7.90431 17.9563C8.07424 17.5132 7.8527 17.0162 7.40954 16.8463C-0.0725399 13.8251 1.93692 2.85332 10.0239 2.71879C13.5803 2.71879 16.6061 5.2568 17.2184 8.75359C17.3003 9.22103 17.7456 9.53366 18.2131 9.45181C18.6806 9.36996 18.9933 8.9246 18.9114 8.45711C18.5497 6.39166 17.4653 4.50323 15.858 3.13974C10.0649 -1.81167 0.974623 2.39382 1.00058 10.0234C0.957264 13.6913 3.36418 17.1769 6.79428 18.4511C6.89551 18.4899 6.99945 18.5083 7.10176 18.5083ZM21.2813 19.1752C21.2813 18.7006 21.666 18.3159 22.1406 18.3159C22.6153 18.3159 23 18.7006 23 19.1752V22.14C22.955 23.2793 21.3267 23.2802 21.2813 22.14V19.1752ZM18.7032 18.3159C18.2286 18.3159 17.8439 18.7006 17.8439 19.1752V22.14C17.8893 23.2802 19.5176 23.2793 19.5626 22.14V19.1752C19.5626 18.7006 19.1779 18.3159 18.7032 18.3159ZM14.4065 19.1752C14.4065 18.7006 14.7912 18.3159 15.2658 18.3159C15.7405 18.3159 16.1252 18.7006 16.1252 19.1752V22.14C16.0802 23.2793 14.4519 23.2802 14.4065 22.14V19.1752ZM11.8284 20.9369C11.3538 20.9369 10.9691 21.3216 10.9691 21.7963V22.14C11.0144 23.2802 12.6428 23.2793 12.6878 22.14V21.7963C12.6878 21.3216 12.303 20.9369 11.8284 20.9369ZM22.9999 15.738V11.9139C22.9999 11.4393 22.6152 11.0546 22.1406 11.0546H18.2735C17.1341 11.0995 17.1333 12.7279 18.2735 12.7733H20.1177L17.5826 15.3083H13.2463C13.0184 15.3083 12.7997 15.3989 12.6386 15.5601L6.66612 21.5325C6.3305 21.8681 6.3305 22.4122 6.66612 22.7478C7.00169 23.0835 7.54584 23.0835 7.88141 22.7478L13.6022 17.0271H17.9386C18.1665 17.0271 18.3851 16.9365 18.5463 16.7753L21.2812 14.0404V15.738C21.3262 16.8774 22.9545 16.8782 22.9999 15.738Z"
                                                        fill="#EDEDED"></path>
                                                </svg>
                                            </div>
                                            <div style="width: 85%;" class="py-1">
                                                <span style="color:#ccc">{{ translate('balance_history') }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="skin.history" class="px-2 pe-2 mb-3" data-bs-toggle="modal"
                                        data-bs-target="#retiro">
                                        <div class="d-flex">
                                            <div style="width: 15%;margin: 4px;" class="me-2">
                                                <i class="fa fa-money-bill-transfer fa-2xl"></i>
                                            </div>
                                            <div style="width: 85%;margin: 4px 4px 0 0;" class="py-1">
                                                <span style="color:#ccc;">Historial de Retiro</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="px-2 pe-2 mb-3"
                                        v-if="skin.my_account.myaccount_type == 'JM' && skin.header_desktop.userMenu.changePassword"
                                        id="changePasswordBtn" data-bs-toggle="modal" data-bs-target="#myAccountJm">
                                        <div class="d-flex">
                                            <div style="width: 15%;" class="me-2">
                                                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                                        d="M23 5.73145C23 4.21529 21.7662 2.98145 20.25 2.98145H3.75C2.23384 2.98145 1 4.21529 1 5.73145V18.269C1 19.7852 2.23384 21.019 3.75 21.019H20.25C21.7662 21.019 23 19.7852 23 18.269V5.73145ZM21.1666 18.269C21.1666 18.7742 20.7551 19.1858 20.25 19.1858H3.75C3.24495 19.1858 2.83339 18.7742 2.83339 18.269V5.85204C2.83339 5.34682 3.24501 4.91781 3.75006 4.91781H20.2501C20.7551 4.91781 21.1666 5.33034 21.1666 5.83556V18.269ZM7.51471 10.5701C7.84285 10.3794 8.26365 10.4921 8.45331 10.8212C8.64315 11.1504 8.53119 11.5701 8.20221 11.7598L7.6458 12.0816L8.20221 12.4033C8.53035 12.5932 8.64315 13.013 8.45331 13.3421C8.32592 13.563 8.09496 13.6859 7.85746 13.6859C7.74114 13.6859 7.62281 13.6565 7.51471 13.5932L6.9583 13.2724V13.915C6.9583 14.2945 6.6503 14.6025 6.2708 14.6025C5.8913 14.6025 5.5833 14.2945 5.5833 13.915V13.2724L5.02773 13.5932C4.91863 13.6565 4.80047 13.6859 4.68398 13.6859C4.44665 13.6859 4.21468 13.563 4.08812 13.3421C3.89846 13.014 4.01024 12.5932 4.33939 12.4033L4.8958 12.0816L4.33939 11.7598C4.01108 11.5701 3.89846 11.1504 4.08812 10.8212C4.27796 10.4921 4.69858 10.3794 5.02689 10.5701L5.5833 10.8909V10.2484C5.5833 9.86885 5.8913 9.56086 6.2708 9.56086C6.6503 9.56086 6.9583 9.86885 6.9583 10.2484V10.8909L7.51471 10.5701ZM14.1823 10.8212C13.9917 10.4921 13.5711 10.3794 13.2437 10.5701L12.6873 10.8909V10.2484C12.6873 9.86885 12.3793 9.56086 11.9998 9.56086C11.6203 9.56086 11.3123 9.86885 11.3123 10.2484V10.8909L10.7559 10.5701C10.4278 10.3794 10.007 10.4921 9.81732 10.8212C9.62748 11.1504 9.74028 11.5701 10.0684 11.7598L10.6248 12.0816L10.0684 12.4033C9.73927 12.5932 9.62748 13.014 9.81732 13.3421C9.94371 13.563 10.1757 13.6859 10.413 13.6859C10.5295 13.6859 10.6478 13.6565 10.7568 13.5932L11.3132 13.2724V13.915C11.3132 14.2945 11.6212 14.6025 12.0007 14.6025C12.3802 14.6025 12.6882 14.2945 12.6882 13.915V13.2724L13.2446 13.5932C13.3518 13.6565 13.4702 13.6859 13.5867 13.6859C13.824 13.6859 14.055 13.563 14.1823 13.3421C14.3722 13.013 14.2594 12.5932 13.9313 12.4033L13.3748 12.0816L13.9313 11.7598C14.2604 11.5701 14.3722 11.1504 14.1823 10.8212ZM18.7124 10.5701C19.0406 10.3794 19.4614 10.4921 19.651 10.8212C19.8409 11.1504 19.7291 11.5701 19.3999 11.7598L18.8435 12.0816L19.3999 12.4033C19.7281 12.5932 19.8409 13.013 19.651 13.3421C19.5236 13.563 19.2927 13.6859 19.0553 13.6859C18.9388 13.6859 18.8205 13.6565 18.7124 13.5932L18.156 13.2724V13.915C18.156 14.2945 17.848 14.6025 17.4685 14.6025C17.089 14.6025 16.781 14.2945 16.781 13.915V13.2724L16.2254 13.5932C16.1165 13.6565 15.9982 13.6859 15.8817 13.6859C15.6443 13.6859 15.4124 13.563 15.286 13.3421C15.0962 13.014 15.2079 12.5932 15.5371 12.4033L16.0935 12.0816L15.5371 11.7598C15.2089 11.5701 15.0962 11.1504 15.286 10.8212C15.4748 10.4921 15.8973 10.3794 16.2246 10.5701L16.781 10.8909V10.2484C16.781 9.86885 17.089 9.56086 17.4685 9.56086C17.848 9.56086 18.156 9.86885 18.156 10.2484V10.8909L18.7124 10.5701Z"
                                                        fill="#EDEDED"></path>
                                                </svg>
                                            </div>
                                            <div style="width: 85%;" class="py-1">
                                                <span style="color:#ccc">{{ translate('change_password') }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="skin.bonos" class="px-2 pe-2 mb-3" role="button" data-bs-toggle="modal"
                                        data-bs-target="#availableBonuses" @click="$refs.availableBonuses.loadBonuses()">
                                        <div class="d-flex">
                                            <div style="width: 15%;" class="me-2 text-center py-1">
                                                <i class="fas fa-gift" style="color:#ededed; font-size: 1.35rem;"></i>
                                            </div>
                                            <div style="width: 85%;" class="py-1">
                                                <span style="color:#ccc">Bonos</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <a v-if="user.user_data?.data?.parentPhone"
                                :href="'https://api.whatsapp.com/send?phone=' + user.user_data?.data?.parentPhone"
                                target="_blank" style="cursor:pointer;overflow: hidden;border-radius: 50%;"
                                class="text-center" :style="skin.header_desktop.login_btn">
                                <div class="p-2" style="cursor:pointer;border-radius: 50%;"
                                    :style="skin.header_desktop.nav_bar_text + skin.my_account.content_background">
                                    <i class="fab fa-whatsapp" :style="{ fontSize: desktopActionIconSize('1.2rem') }"></i>
                                </div>
                            </a>
                            <div v-if="user?.user_data?.data?.cuenta" role="button"
                                style="cursor:pointer;overflow: hidden;border-radius: 50%;" class="text-center"
                                :style="skin.header_desktop.login_btn" @click="openContactAgent">
                                <div class="p-2" style="cursor:pointer;border-radius: 50%;"
                                    :style="skin.header_desktop.nav_bar_text + skin.my_account.content_background">
                                    <i class="fa fa-coins" :style="{ fontSize: desktopActionIconSize('1.1rem') }"></i>
                                </div>
                            </div>
                            <!-- boton de soporte de jivo -->
                            <div v-if="!hasLateralMenu" style="cursor:pointer;overflow: hidden;border-radius: 50%;"
                                class="text-center" :style="skin.header_desktop.login_btn"
                                @click="openSupportModalJivo()">
                                <div class="p-2" style="cursor:pointer;border-radius: 50%;"
                                    :style="skin.header_desktop.nav_bar_text + skin.my_account.content_background">
                                    <svg :style="{ width: desktopActionIconSize('1.3rem'), height: desktopActionIconSize('1.3rem') }" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_10434_32190)">
                                            <path
                                                d="M18.5625 10.3125C17.6579 10.3125 16.9219 11.0485 16.9219 11.9531V18.5156C16.9219 19.4203 17.6579 20.1562 18.5625 20.1562C19.4671 20.1562 20.2031 19.4203 20.2031 18.5156V11.9531C20.2031 11.0485 19.4671 10.3125 18.5625 10.3125Z"
                                                fill="currentColor"></path>
                                            <path
                                                d="M10.5938 19.7812C9.67711 19.7812 8.89556 20.3691 8.60531 21.1875H7.875C7.09495 21.1875 6.43364 20.6697 6.21633 19.9599C6.72947 19.6826 7.07812 19.1399 7.07812 18.5156V11.9531C7.07812 11.047 6.34359 10.3125 5.4375 10.3125C4.53141 10.3125 3.79688 11.047 3.79688 11.9531V18.5156C3.79688 19.1905 4.20455 19.77 4.78697 20.0219C5.05547 21.483 6.3375 22.5938 7.875 22.5938H8.60531C8.89556 23.4121 9.67711 24 10.5938 24C11.7569 24 12.7031 23.0537 12.7031 21.8906C12.7031 20.7275 11.7569 19.7812 10.5938 19.7812Z"
                                                fill="currentColor"></path>
                                            <path
                                                d="M16.1099 7.7158H16.0985C16.1062 6.3703 16.1096 4.98636 16.0929 4.78555C16.0531 4.30878 15.7645 3.91925 15.3576 3.7932C14.9526 3.66786 14.5243 3.82217 14.2114 4.20608C13.8879 4.60302 12.4079 7.271 11.962 8.07927C11.8418 8.29705 11.8457 8.56217 11.9722 8.77639C12.0986 8.99061 12.3289 9.12205 12.5776 9.12205H14.6826C14.6801 9.45833 14.6776 9.7805 14.6751 10.073C14.6717 10.4614 14.9838 10.7789 15.3721 10.7822H15.3783C15.7637 10.7822 16.0779 10.4714 16.0812 10.0851C16.0832 9.85367 16.086 9.51631 16.089 9.12205H16.1099C16.4982 9.12205 16.813 8.80724 16.813 8.41892C16.813 8.03061 16.4982 7.7158 16.1099 7.7158ZM14.6919 7.7158H13.7729C14.1075 7.11819 14.4327 6.54519 14.6985 6.08624C14.6976 6.55789 14.6952 7.12677 14.6919 7.7158Z"
                                                fill="currentColor"></path>
                                            <path
                                                d="M11.736 6.23705C11.7502 6.14353 11.7757 6.01134 11.7815 5.86481C11.7815 4.6987 10.8328 3.75 9.6666 3.75C8.65827 3.75 7.78555 4.46733 7.59144 5.45569C7.51659 5.83673 7.76484 6.2063 8.14588 6.28111C8.52693 6.35597 8.89649 6.10772 8.9713 5.72667C9.03623 5.39616 9.32863 5.15625 9.66655 5.15625C10.0448 5.15625 10.3548 5.45409 10.3742 5.82759L10.3586 5.95022C10.2919 6.20972 10.1299 6.52781 9.88846 6.87277C9.01555 8.11997 8.49468 8.80195 8.21488 9.16838C7.86351 9.62841 7.68716 9.85931 7.80562 10.2443C7.87569 10.4722 8.04805 10.647 8.27844 10.7238C8.37112 10.7547 8.45465 10.7826 9.54149 10.7826C9.96355 10.7826 10.537 10.7783 11.321 10.7685C11.7093 10.7636 12.0201 10.4449 12.0153 10.0566C12.0104 9.67125 11.6966 9.36225 11.3124 9.36225C11.3094 9.36225 11.3063 9.36225 11.3034 9.3623C10.8045 9.36858 10.2774 9.37294 9.82129 9.37444C10.1197 8.97305 10.5187 8.42484 11.0407 7.67911C11.3989 7.16705 11.6329 6.68189 11.736 6.23705Z"
                                                fill="currentColor"></path>
                                            <path
                                                d="M23.0156 12.0752V11.0156C23.0156 8.07323 21.8698 5.307 19.7892 3.22645C17.7086 1.14581 14.9424 0 12 0C9.05761 0 6.29138 1.14581 4.21078 3.22641C2.13019 5.30695 0.984375 8.07323 0.984375 11.0156V12.0752C0.419484 12.4541 0.046875 13.0983 0.046875 13.8281V16.6406C0.046875 17.8037 0.993141 18.75 2.15625 18.75H2.39062V11.0156C2.39062 5.71702 6.70139 1.40625 12 1.40625C17.2986 1.40625 21.6094 5.71697 21.6094 11.0156V18.75H21.8438C23.0069 18.75 23.9531 17.8037 23.9531 16.6406V13.8281C23.9531 13.0983 23.5805 12.4541 23.0156 12.0752Z"
                                                fill="currentColor"></path>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_10434_32190">
                                                <rect width="24" height="24" fill="white"></rect>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                            </div>
                            <!-- coins tonker -->
                            <div v-if="skin.tonder && canUseTonder" style="cursor:pointer;overflow: hidden;border-radius: 50%;"
                                class="text-center" :style="skin.header_desktop.login_btn"
                                @click="change_view('tonder')">
                                <div class="p-2" style="cursor:pointer;border-radius: 50%;"
                                    :style="skin.header_desktop.nav_bar_text + skin.my_account.content_background">
                                    <svg :style="{ width: desktopActionIconSize('1.3rem'), height: desktopActionIconSize('1.3rem') }" fill="#f5f5f5" viewBox="0 0 60 60"
                                        id="Capa_1" version="1.1" xml:space="preserve"
                                        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                        stroke="#f5f5f5">
                                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round">
                                        </g>
                                        <g id="SVGRepo_iconCarrier">
                                            <g>
                                                <path
                                                    d="M36,0h-9c-8.411,0-15,13.178-15,30s6.589,30,15,30h9c8.411,0,15-13.178,15-30S44.411,0,36,0z M30.511,2 c-0.04,0.031-0.079,0.07-0.119,0.101c-0.293,0.23-0.582,0.473-0.865,0.738c-0.02,0.019-0.041,0.035-0.061,0.054 c-0.3,0.283-0.592,0.591-0.879,0.912C28.529,3.87,28.471,3.934,28.414,4h-6.14C23.747,2.717,25.342,2,27,2H30.511z M20.414,54 c-0.467-0.607-0.914-1.277-1.342-2h6.637c0.02,0.036,0.038,0.074,0.058,0.111c0.022,0.04,0.042,0.082,0.064,0.122 c0.241,0.44,0.491,0.859,0.746,1.267c0.057,0.091,0.114,0.179,0.171,0.268c0.05,0.077,0.098,0.157,0.149,0.232H20.414z M16.412,14 h6.835c-0.054,0.176-0.109,0.351-0.162,0.53c-0.03,0.103-0.059,0.208-0.089,0.312c-0.109,0.381-0.215,0.766-0.316,1.158h-6.874 C15.996,15.315,16.198,14.648,16.412,14z M18.007,10h6.727c-0.136,0.308-0.27,0.619-0.4,0.939 c-0.029,0.071-0.056,0.145-0.085,0.217c-0.111,0.279-0.222,0.558-0.328,0.844h-6.786C17.412,11.304,17.703,10.637,18.007,10z M20.414,6h6.484c-0.05,0.076-0.099,0.155-0.149,0.232C26.691,6.321,26.634,6.41,26.577,6.5c-0.255,0.407-0.505,0.827-0.746,1.267 c-0.022,0.04-0.042,0.082-0.064,0.122C25.747,7.926,25.728,7.964,25.709,8h-6.637C19.5,7.277,19.947,6.607,20.414,6z M14,30 c0-0.672,0.016-1.338,0.039-2h6.996C21.014,28.661,21,29.326,21,30s0.014,1.339,0.035,2h-6.996C14.016,31.338,14,30.672,14,30z M21.192,25.117c-0.005,0.062-0.011,0.123-0.016,0.186c-0.017,0.23-0.03,0.465-0.045,0.697h-6.99c0.071-1.017,0.167-2.018,0.29-3 h6.964c-0.009,0.081-0.014,0.164-0.023,0.245C21.303,23.862,21.242,24.485,21.192,25.117z M21.131,34 c0.015,0.232,0.027,0.466,0.045,0.697c0.005,0.063,0.011,0.124,0.016,0.186c0.05,0.632,0.111,1.255,0.179,1.872 c0.009,0.081,0.014,0.165,0.023,0.245h-6.964c-0.122-0.982-0.219-1.983-0.29-3H21.131z M21.661,39 c0.008,0.05,0.016,0.098,0.024,0.148c0.015,0.094,0.031,0.186,0.047,0.28c0.091,0.57,0.192,1.131,0.299,1.685 c0.025,0.13,0.049,0.261,0.075,0.389c0.034,0.167,0.068,0.333,0.103,0.498h-6.907c-0.221-0.971-0.413-1.974-0.58-3H21.661z M22.209,18c-0.035,0.165-0.069,0.331-0.103,0.498c-0.026,0.129-0.05,0.259-0.075,0.389c-0.107,0.554-0.208,1.115-0.299,1.685 c-0.015,0.094-0.032,0.186-0.047,0.28c-0.008,0.049-0.016,0.098-0.024,0.148h-6.94c0.168-1.026,0.36-2.029,0.58-3H22.209z M22.681,44c0.101,0.392,0.207,0.777,0.316,1.158c0.03,0.104,0.058,0.209,0.089,0.312c0.053,0.178,0.107,0.354,0.162,0.53h-6.835 c-0.214-0.648-0.416-1.315-0.605-2H22.681z M23.922,48c0.106,0.287,0.217,0.566,0.328,0.844c0.029,0.072,0.056,0.146,0.085,0.217 c0.13,0.319,0.264,0.631,0.4,0.939h-6.727c-0.305-0.637-0.596-1.304-0.871-2H23.922z M30.511,58H27c-1.658,0-3.253-0.717-4.727-2 h6.14c0.057,0.066,0.115,0.13,0.173,0.195c0.288,0.321,0.58,0.629,0.879,0.912c0.02,0.019,0.041,0.036,0.061,0.054 c0.283,0.264,0.572,0.507,0.865,0.737C30.432,57.93,30.471,57.969,30.511,58z M36,58c-7.047,0-13-12.822-13-28S28.953,2,36,2 s13,12.822,13,28S43.047,58,36,58z">
                                                </path>
                                                <path
                                                    d="M36,4c-3.359,0-6.973,4.657-9.108,11.97l-0.096-0.265l-0.723,3.45c-0.101,0.483-0.179,0.981-0.266,1.473 c-0.017,0.097-0.036,0.193-0.052,0.291c-0.095,0.558-0.181,1.121-0.258,1.69c-0.053,0.39-0.103,0.785-0.148,1.184 c-0.04,0.359-0.08,0.717-0.112,1.08c-0.063,0.673-0.113,1.357-0.151,2.05c-0.007,0.128-0.016,0.255-0.022,0.383 C25.022,28.189,25,29.087,25,30c0,0.889,0.022,1.765,0.062,2.626c0.006,0.135,0.015,0.269,0.022,0.404 c0.036,0.666,0.084,1.322,0.142,1.969c0.035,0.399,0.077,0.794,0.121,1.188c0.04,0.35,0.083,0.697,0.129,1.041 c0.083,0.627,0.176,1.246,0.281,1.859c0.01,0.061,0.022,0.121,0.032,0.182c0.084,0.481,0.159,0.969,0.256,1.441l0.701,3.398 l0.094-0.252C28.969,51.271,32.614,56,36,56c5.192,0,11-11.119,11-26S41.192,4,36,4z M28.048,25.062 c0.284,0.785,0.907,1.324,1.626,1.407l2.073,0.239l0.253-0.777c0.67-2.056,1.829-3.228,3.443-3.484l0.679-0.108l0.143-0.673 c0.093-0.438,0.26-0.604,0.255-0.617l0.75,0.231c0.087,0.027,0.385,0.3,0.568,0.942l0.128,0.449l0.426,0.19 c0.564,0.251,1.072,0.599,1.51,1.033c0.188,0.186,0.327,0.338,0.439,0.462c0.39,0.427,0.697,0.695,1.188,0.773 c-0.002,0.005-0.004,0.011-0.006,0.017c-0.534,1.464-0.59,3.156-0.542,4.318c0.007,0.175,0.011,0.354,0.011,0.537 c0,4.036-0.831,6.304-2.614,7.138l-0.414,0.193l-0.125,0.44c-0.183,0.647-0.481,0.922-0.57,0.95l-0.704,0.238 c-0.04-0.021-0.208-0.187-0.3-0.625l-0.143-0.672l-0.679-0.108c-1.615-0.256-2.773-1.429-3.443-3.484l-0.253-0.777l-2.082,0.24 c-0.71,0.082-1.331,0.611-1.617,1.38l-0.632,1.689c-0.025-0.201-0.052-0.399-0.075-0.603c-0.07-0.626-0.127-1.26-0.175-1.898 c-0.026-0.344-0.057-0.682-0.076-1.033C27.036,32.057,27,31.036,27,30c0-1.044,0.037-2.071,0.093-3.089 c0.02-0.348,0.05-0.683,0.075-1.024c0.049-0.656,0.109-1.305,0.181-1.948c0.023-0.204,0.049-0.403,0.075-0.604L28.048,25.062z M36,54c-2.332,0-6.09-4.936-7.922-13.454l1.844-4.933c0.018-0.048,0.038-0.082,0.053-0.103l0.409-0.047 c1.045,2.524,2.699,3.547,4.12,3.932c0.232,0.574,0.592,1.021,1.046,1.288c0.474,0.279,1.028,0.343,1.558,0.18l0.749-0.23 c0.751-0.23,1.392-0.923,1.765-1.888c3.011-1.719,3.371-5.784,3.371-8.745c0-0.211-0.005-0.417-0.013-0.62 c-0.057-1.387,0.093-2.647,0.423-3.549c0.183-0.502,0.317-0.722,0.38-0.808c0.318-0.432,0.276-0.991,0.093-1.354 c-0.191-0.378-0.563-0.613-0.971-0.613c-0.225,0-0.49,0.017-0.786,0.066c-0.065,0.011-0.122,0.021-0.17,0.027 c-0.038-0.041-0.08-0.088-0.129-0.143c-0.13-0.143-0.292-0.319-0.509-0.535c-0.504-0.498-1.073-0.915-1.698-1.242 c-0.375-0.952-1.011-1.634-1.754-1.862l-0.749-0.23c-0.53-0.164-1.084-0.1-1.558,0.18c-0.454,0.267-0.814,0.713-1.046,1.287 c-1.421,0.385-3.075,1.408-4.12,3.932l-0.399-0.046c-0.016-0.022-0.038-0.058-0.056-0.108l-1.823-5.05C29.948,10.89,33.68,6,36,6 c3.173,0,9,9.112,9,24S39.173,54,36,54z">
                                                </path>
                                                <path
                                                    d="M9,46.905c-0.552,0-1,0.448-1,1v3.497c-2.987-1.283-6-3.355-6-6.497c0-2.158,1.932-4.291,5.439-6.007 c0.496-0.243,0.702-0.842,0.459-1.338c-0.243-0.496-0.84-0.701-1.338-0.459C1.138,39.754,0,42.81,0,44.905 c0,2.419,1.278,5.717,7.011,8.242L4.4,55.105c-0.442,0.331-0.531,0.958-0.2,1.4c0.196,0.262,0.497,0.4,0.801,0.4 c0.208,0,0.419-0.065,0.599-0.2l4-3c0.019-0.014,0.028-0.036,0.046-0.052c0.053-0.045,0.094-0.097,0.136-0.153 c0.038-0.05,0.076-0.098,0.103-0.153c0.021-0.042,0.036-0.085,0.051-0.13c0.001-0.002,0.003-0.004,0.004-0.006 c0.005-0.013,0.002-0.025,0.006-0.038c0.019-0.067,0.035-0.131,0.04-0.2C9.988,52.95,10,52.929,10,52.905v-5 C10,47.353,9.552,46.905,9,46.905z">
                                                </path>
                                                <path
                                                    d="M52.989,5.853L55.6,3.895c0.442-0.331,0.531-0.958,0.2-1.4c-0.331-0.44-0.956-0.532-1.4-0.2l-4,3 c-0.019,0.014-0.028,0.036-0.046,0.052c-0.053,0.045-0.094,0.097-0.136,0.153c-0.038,0.05-0.076,0.098-0.103,0.153 c-0.021,0.042-0.036,0.085-0.051,0.131c-0.001,0.002-0.003,0.003-0.003,0.006c-0.005,0.013-0.002,0.026-0.006,0.038 c-0.019,0.067-0.035,0.131-0.04,0.2C50.012,6.05,50,6.071,50,6.095v5c0,0.552,0.448,1,1,1s1-0.448,1-1V7.598 c2.987,1.283,6,3.355,6,6.497c0,2.158-1.932,4.291-5.439,6.007c-0.496,0.243-0.702,0.842-0.459,1.338 C52.275,21.794,52.631,22,53.001,22c0.147,0,0.297-0.033,0.438-0.102C58.862,19.246,60,16.19,60,14.095 C60,11.676,58.722,8.377,52.989,5.853z">
                                                </path>
                                            </g>
                                            <g></g>
                                            <g></g>
                                            <g></g>
                                            <g></g>
                                            <g></g>
                                            <g></g>
                                            <g></g>
                                            <g></g>
                                            <g></g>
                                            <g></g>
                                            <g></g>
                                            <g></g>
                                            <g></g>
                                            <g></g>
                                            <g></g>
                                        </g>
                                    </svg>
                                </div>
                            </div>
                            <!-- coins espiral app -->
                            <div v-if="skin.espiral_app && !skin.tonder" style="cursor:pointer;overflow: hidden;border-radius: 50%;"
                                class="text-center" :style="skin.header_desktop.login_btn"
                                @click="change_view('espiral_app')">
                                <div class="p-2" style="cursor:pointer;border-radius: 50%;"
                                    :style="skin.header_desktop.nav_bar_text + skin.my_account.content_background">
                                    <svg :style="{ width: desktopActionIconSize('1.3rem'), height: desktopActionIconSize('1.3rem') }" fill="#f5f5f5" viewBox="0 0 512 512"
                                        xmlns="http://www.w3.org/2000/svg" stroke="#f5f5f5">
                                        <path d="M448 64H64C28.65 64 0 92.65 0 128v256c0 35.35 28.65 64 64 64h384c35.35 0 64-28.65 64-64V128C512 92.65 483.35 64 448 64zM64 96h384c17.67 0 32 14.33 32 32v32H32V128C32 110.33 46.33 96 64 96zM448 416H64c-17.67 0-32-14.33-32-32V192h448v192C480 401.67 465.67 416 448 416zM160 288c0 17.67-14.33 32-32 32s-32-14.33-32-32 14.33-32 32-32S160 270.33 160 288z"/>
                                    </svg>
                                </div>
                            </div>
                            <!-- logout -->
                            <div style="cursor:pointer;overflow: hidden;border-radius: 50%;" class="text-center"
                                :style="skin.header_desktop.login_btn" @click="logout">
                                <div class="p-2" style="cursor:pointer;border-radius: 50%;"
                                    :style="skin.header_desktop.nav_bar_text + skin.my_account.content_background">
                                    <svg :style="{ width: desktopActionIconSize('1.3rem'), height: desktopActionIconSize('1.3rem') }" viewBox="0 0 28 28" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M20 10L24 14M24 14L20 18M24 14H11M17 6.20404C15.7252 5.43827 14.2452 5 12.6667 5C7.8802 5 4 9.02944 4 14C4 18.9706 7.8802 23 12.6667 23C14.2452 23 15.7252 22.5617 17 21.796"
                                            stroke="currentColor" stroke-width="2.4" stroke-linecap="round"
                                            stroke-linejoin="round"></path>
                                    </svg>
                                </div>
                            </div>
                            <div class="header-desktop__separator"></div>
                            <div v-if="!skin.lobby">
                                <languageSelector :skin="skin" :language="language" :movil="movil">
                                </languageSelector>
                            </div>
                        </div>

                    </div>
                </div>
            </nav>
            <div>
                <historialRetiro v-if="skin.history" v-bind:skin="skin" v-bind:language="language"
                    v-bind:translation="translation" />
                <myAccountJM v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
                <availableBonuses ref="availableBonuses" :skin="skin" :user="user" />
                <template v-if="skin?.gamanza?.mainFrame?.profileDropdown?.enabled">
                    <button id="gamanzaAccountModalBtn" class="btn btn-primary" data-bs-toggle="modal"
                        data-bs-target="#myAccountJm" style="display:none;"></button>
                </template>
                <!-- Button trigger modal -->
                <button id="register_btn" class="btn btn-primary" data-bs-toggle="modal" href="#registerModalToggle"
                    style="display:none;"></button>

                <historialIngresos v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
                <register2 v-if="useRegisterOther" v-bind:skin="skin" v-bind:language="language"
                    v-bind:translation="translation" />
                <register v-else v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
            </div>
        </div>
    </div>
</template>

<script>
import historialRetiro from "./historialRetiro.vue";
import myAccountJM from "./my_account.vue";
import login from "./login.vue";
import register from './register.vue';
import register2 from './register2.vue';
import languageSelector from './language.vue';
import historialIngresos from "./historialIngresos.vue";
import availableBonuses from "./bonuses.vue";
import GamanzaAccountDropdown from "../../gamanza/GamanzaAccountDropdown.vue";
import { getGamanzaMenuCategories, isGamanzaMenuCategory as isGamanzaMenuCategoryHelper } from '@/utils/gamanzaMenuCategories';
import axios from 'axios';
import { mapState, mapActions } from "vuex";
import {
    shouldUseGamanzaProfileDropdown,
    mergeGamanzaMenuCategories
} from '../../../utils/gamanzaProfileDropdown';

import { getPromotionsApiKey, getPromotionsApiUrl } from '../../../services/promotionsApi';

export default {
    name: "mainHeader",
    props: ['skin', 'language', 'translation'],
    data() {
        return {
            showBalance: false,
            userDataLoaded: false,
            movil: "desktop",
            balance: {
                saldo: 0,
                conversion: 0,
                view: "SALDO",
                switch: 1
            },
            bonus: 0,
            casinoBonusBalance: 0,
            sportsbookBonusBalance: 0,
            frozen: 0,
            newMessage: false,
            supportTickets: [],
            saldo_interval: null,
            visibleMenuCount: Number.MAX_SAFE_INTEGER,
            menuMeasureFrame: null,
            menuResizeObserver: null,
            overflowMenuOpen: false
        }


    },
    components: {
        historialRetiro,
        myAccountJM,
        login,
        register,
        register2,
        languageSelector,
        historialIngresos,
        availableBonuses,
        GamanzaAccountDropdown
    },
    methods: {
        ...mapActions("notification", ["clearNotificacion"]),
        desktopActionIconSize(fallback) {
            return this.$props.skin.header_desktop?.action_icon_size || fallback;
        },
        scheduleMenuLayout() {
            if (this.menuMeasureFrame) {
                window.cancelAnimationFrame(this.menuMeasureFrame);
            }
            this.menuMeasureFrame = window.requestAnimationFrame(() => {
                this.visibleMenuCount = this.filteredCategories.length;
                this.$nextTick(this.measureMenuLayout);
            });
        },
        measureMenuLayout() {
            const container = this.$refs.menuContainer;
            const menuList = this.$refs.menuList;
            const items = this.$refs.menuItem || [];
            if (!container || !menuList || !items.length) {
                return;
            }

            const fixedActionWidth = this.$refs.menuFixedAction?.offsetWidth || 0;
            const navigationGap = parseFloat(window.getComputedStyle(menuList).columnGap) || 0;
            const availableWidth = container.clientWidth - fixedActionWidth - (fixedActionWidth ? navigationGap : 0);
            const itemWidths = items.map(item => item.offsetWidth);
            const totalWidth = itemWidths.reduce((total, width) => total + width, 0)
                + (navigationGap * Math.max(0, itemWidths.length - 1));
            if (totalWidth <= availableWidth) {
                this.visibleMenuCount = this.filteredCategories.length;
                return;
            }

            const overflowToggleWidth = 44;
            let usedWidth = 0;
            let visibleCount = 0;
            for (const width of itemWidths) {
                const gapBefore = visibleCount ? navigationGap : 0;
                if (usedWidth + gapBefore + width + navigationGap + overflowToggleWidth > availableWidth) {
                    break;
                }
                usedWidth += gapBefore + width;
                visibleCount++;
            }
            this.visibleMenuCount = Math.max(1, visibleCount);
        },
        isGamanzaMenuCategory(category) {
            return isGamanzaMenuCategoryHelper(category);
        },
        menuLabel(item) {
            return this.isGamanzaMenuCategory(item.category)
                ? item.name
                : this.translate(item.name1);
        },
        async loadBonusBalances(playerKey) {
            try {
                const response = await axios.get(
                    `${getPromotionsApiUrl(this.$store.getters.getDomain)}/bonus/balance/${encodeURIComponent(playerKey)}`,
                    {
                        headers: {
                            'w-api-key': getPromotionsApiKey(this.$store.getters.getDomain),
                            'w-api-token': `${this.$store.state.user_token}_${this.user.site_id}`
                        }
                    }
                );
                const bonusBalances = response.data?.data ?? response.data;

                this.casinoBonusBalance = Number(bonusBalances?.casino_bonus_balance) || 0;
                this.sportsbookBonusBalance = Number(bonusBalances?.sportsbook_bonus_balance) || 0;
            } catch (error) {
                this.casinoBonusBalance = 0;
                this.sportsbookBonusBalance = 0;
            }
        },
        handleUserMenuShow(event) {
            const userMenuDropdown = document.getElementById('userMenuDropdown');

            if (!userMenuDropdown || !event.target?.contains(userMenuDropdown)) return;

            const playerKey = this.casinoBonusPlayerKey;

            if (playerKey) {
                this.loadBonusBalances(playerKey);
            }
        },
        closeUserMenu() {
            const userMenuDropdown = document.getElementById('userMenuDropdown');

            if (userMenuDropdown?.getAttribute('aria-expanded') === 'true') {
                userMenuDropdown.click();
            }
        },
        openAccountModal() {
            document.getElementById('gamanzaAccountModalBtn')?.click();
        },
        getNavBarStyle(view) {
            return view === this.$store.state?.infoRouter?.category
                ? (this.$props.skin.header_desktop.selection1 ?? 'color: white !important')
                : '';
        },
        openContactAgent() {
            this.$root.$emit('openContactAgent');
        },
        openBalanceGateway() {
            if (this.skin.tonder) {
                if (this.canUseTonder) {
                    this.change_view('tonder');
                }
                return;
            }

            if (this.skin.espiral_app) {
                this.change_view('espiral_app');
            }
        },
        action() {
            let customButton = this.$props.skin.customActionButton;
            if (customButton.action == 'redirection') {
                let url = customButton.actionData.url;
                let parameters = customButton.actionData.parameters;
                parameters.forEach(param => {
                    url += (url.includes('?') ? '&' : '?') + `${param}=${encodeURIComponent(this.user.user_data.data[param])}`;
                });
                // console.log(url, this.user.user_data.data, this.$props.skin.customActionButton);
                window.open(url, '_blank');
            }
        },
        showBalanceAction() {
            if (!this.showBalance) {
                this.$store.dispatch('getProfile', {
                    token: this.user.token,
                    site_id: this.user.site_id,
                    site: this.user.site,
                    prefix: this.user.prefix,
                    playerId: this.user.user_data?.data?.user_id,
                    source: "main"
                });
                this.showBalance = true
            }
            else {
                this.showBalance = false
            }
        },
        openSupportModalJivo() {
            const jivoElement = this.jivoElement1;
            if (this.jivo_modal_flag) {
                if (jivoElement) {
                    jivoElement.style.display = 'none';
                }
                this.$store.dispatch("setJivo_modal_flag", false);
            } else {
                if (jivoElement) {
                    jivoElement.style.display = 'block';
                    jivo_api.open()
                }
                setTimeout(() => {
                    jivo_api.open()
                }, 600);
                this.$store.dispatch("setJivo_modal_flag", true);
                this.$store.dispatch("setMessage", false);
            }
        },
        getMovements() {
            this.$root.$emit('getMovementsHistory');
        },
        getIngresos() {
            this.$root.$emit('getIngresosHistory');
        },
        balanceParsed(val, fiat) {
            let tasa = 1;
            if (this.$props.skin.conversion ? (this.$props.skin.conversion.enabled ? true : false) : false) {
                tasa = this.currency.rate;
            }
            return (fiat != 'BETC' ? (fiat == 'USDT' ? val * tasa : val * tasa * this.user.user_data.data.tasa) : val).toFixed(2);
        },
        terms() {
            let url = "";
            let lang = this.$props.language == 'es' ? 'spa' : (this.$props.language == 'en' ? 'eng' : (this.$props.language == 'pt' ? 'pt-br' : 'spa'));
            if (this.user.prefix == "external") {
                url = "https://docs.betsw3.xyz/terms/" + lang + "/?site=" + this.user.site.toUpperCase() + "&link=" + this.user.site;
            }
            else {
                let domain_formated = this.user.domain.split('//')[1];
                let domain_name1 = domain_formated.split('.')[1].toUpperCase();
                let domain_name2 = domain_formated.split('.')[1] + '.' + domain_formated.split('.')[2];
                url = "https://docs.betsw3.xyz/terms/" + lang + "/?site=" + domain_name1 + "&link=" + domain_name2;
            }

            window.open(url, '_blank').focus();
        },
        login() {
            this.$store.commit('toggleShowLogin')
        },
        register() {
            document.getElementById('register_btn').click();
        },
        logout() {
            this.$store.dispatch('logOut');
            this.$root.$emit('forceRender');
        },
        my_account() {
            window.parent.postMessage(
                {
                    action: 'openSlider',
                    tab: 'recentBets'
                },
                '*'
            );
        },
        change_view(view) {
            this.$store.dispatch("changeView", view);
        },
        toggleOverflowMenu() {
            this.overflowMenuOpen = !this.overflowMenuOpen;
        },
        closeOverflowMenuFromOutside(event) {
            const menuOverflow = this.$refs.menuOverflow;
            if (this.overflowMenuOpen && menuOverflow && !menuOverflow.contains(event.target)) {
                this.overflowMenuOpen = false;
            }
        },
        selectOverflowCategory(category) {
            this.overflowMenuOpen = false;
            this.change_view(category);
        },
        translate(text) {
            if (text) {
                if (this.$props.translation[text]) {
                    return this.$props.translation[text][this.$props.language];
                }
                else {
                    var new_text_serched = text.replace(/ /g, "_");
                    if (this.$props.translation[new_text_serched]) {
                        return this.$props.translation[new_text_serched][this.$props.language];
                    }
                }
                return text;
            }
        },
        countDays(init) {
            // Crear dos objetos Date con las fechas que quieres comparar
            var fecha1 = new Date(init);
            var fecha2 = new Date();

            // Calcular la diferencia en milisegundos entre las dos fechas
            var diferenciaEnMilisegundos = fecha2 - fecha1;

            // Convertir la diferencia en días
            var diferenciaEnDias = diferenciaEnMilisegundos / (1000 * 60 * 60 * 24);

            // Redondear la diferencia si es necesario
            diferenciaEnDias = Math.round(diferenciaEnDias);
            return diferenciaEnDias;
        },
        ocultarLogin() {
            this.$store.commit('setShowLogin', false)
        },
        toggleLateralMenu() {
            this.$store.dispatch('toggleLateralMenu');
        },
    },
    computed: {
        ...mapState("notification", ["msg", "status"]),
        filteredCategories() {
            return mergeGamanzaMenuCategories(this.$props.skin.categories, this.gamanzaMenuCategories);
        },
        visibleMenuCategories() {
            return this.filteredCategories.slice(0, this.visibleMenuCount);
        },
        overflowMenuCategories() {
            return this.filteredCategories.slice(this.visibleMenuCount);
        },
        hasActiveOverflowCategory() {
            return this.overflowMenuCategories.some(item => item.category === this.$store.state?.infoRouter?.category);
        },
        gamanzaMenuCategories() {
            return getGamanzaMenuCategories(this.skin, this.user, this.gamanzaReady, this.language);
        },
        showLogin() {
            return this.$store.state.showLogin
        },
        jivo_modal_flag() {
            return this.$store.getters["getModalFlag"]
        },
        message_recived() {
            return this.$store.getters["getMessage"]
        },
        actualRoute() {
            return this.$store.getters["getActualRoute"]
        },
        useRegisterOther() {
            return Boolean(this.skin && this.skin.register_other);
        },
        jivoElement1() {
            return this.$store.getters['jivoElement1'];
        },
        user() {
            let data = this.$store.getters['getUserData'];
            if (data.user_data.data) {
                this.balance.saldo = data.user_data.data.balance;
                this.bonus = data.user_data.data.balance_bonus;
                this.frozen = data.user_data.data.balance_frozen;
                this.balance.conversion = data.user_data.data.balance * data.user_data.data.tasa;
                this.userDataLoaded = true;
            }
            return data;
        },
        canUseTonder() {
            return Number(this.user?.user_data?.data?.edit_tickets) === 0;
        },
        showStandardBonusBalances() {
            const siteId = this.user?.site_id ?? this.user?.user_data?.data?.site_id;
            return Number(siteId) !== 86251;
        },
        casinoBonusPlayerKey() {
            if (!this.skin?.bonos) return '';
            const playerId = this.user?.user_data?.data?.user_id;
            const siteId = this.user?.site_id ?? this.user?.user_data?.data?.site_id;
            return playerId && siteId ? `${playerId}_${siteId}` : '';
        },
        currency() {
            return this.$store.getters['getCurrency'];
        },
        hasLateralMenu() {
            return !!this.skin?.lateral_menu?.enabled;
        },
        lateralMenuOpen() {
            return this.$store.getters['getLateralMenu'];
        },
        gamanzaReady() {
            return this.$store.getters['getGamanzaReady'];
        },
        showGamanzaProfileDropdown() {
            return shouldUseGamanzaProfileDropdown({
                skin: this.skin,
                user: this.user,
                gamanzaReady: this.gamanzaReady
            });
        },
        header_productsQty() {
            let products = [this.$props.skin.poker, this.$props.skin.prematch, this.$props.skin.casinoN, this.$props.skin.casino_live, this.$props.skin.hipicas, this.$props.skin.login, this.$props.skin.logout];
            return products.filter(x => x == true).length + 1;
        }
    },
    mounted() {
        this.$store.dispatch("setHeaderHeight", document.getElementById("mainHeader").offsetHeight + 5);
        document.addEventListener('show.bs.dropdown', this.handleUserMenuShow);
        document.addEventListener('click', this.closeOverflowMenuFromOutside);
        this.$root.$on('openLogin', () => {
            this.login();
        });
        window.addEventListener('resize', this.scheduleMenuLayout);
        this.menuResizeObserver = new ResizeObserver(this.scheduleMenuLayout);
        this.menuResizeObserver.observe(this.$refs.menuContainer);
        this.scheduleMenuLayout();
    },
    watch: {
        filteredCategories() {
            this.scheduleMenuLayout();
        },
        language() {
            this.scheduleMenuLayout();
        },
        showBalance(newVal, oldVal) {
            if (newVal) {
                let self = this
                setTimeout(() => {
                    self.showBalance = false
                }, 5000);
            }
        }
    },
    created() {
        const self = this;
        let balanceRequestTime = 8000;
        // if (self.$props.skin.demo_user?.enabled) {
        //     self.$store.dispatch('login_demo', {
        //         username: self.$props.skin.demo_user.user,
        //         password: self.$props.skin.demo_user.password,
        //     });
        // }
        this.saldo_interval = setInterval(function () {
            try {
                if (self.user.user_data.data) {
                    self.$store.dispatch('getProfile', {
                        token: self.user.token,
                        site_id: self.user.site_id,
                        site: self.user.site,
                        prefix: self.user.prefix,
                        playerId: self.user.user_data?.data?.user_id,
                        source: "main"
                    });
                }
            } catch (error) {
                self.$store.dispatch('logOut');
                if (self.saldo_interval) {
                    clearInterval(self.saldo_interval);
                }
            }
        }, balanceRequestTime);
    },
    beforeDestroy() {
        this.$root.$off('openLogin');
        document.removeEventListener('show.bs.dropdown', this.handleUserMenuShow);
        document.removeEventListener('click', this.closeOverflowMenuFromOutside);
        window.removeEventListener('resize', this.scheduleMenuLayout);
        if (this.menuResizeObserver) {
            this.menuResizeObserver.disconnect();
        }
        if (this.menuMeasureFrame) {
            window.cancelAnimationFrame(this.menuMeasureFrame);
        }

        if (this.saldo_interval) {
            clearInterval(this.saldo_interval);
        }

    }
}
</script>

<style scoped>
.center_div {
    width: 90%;
    /* Can be in percentage also. */
    height: auto;
    margin: 0 auto;
    padding: 0px;
    position: relative;
}

.ganamos-header__layout {
    align-items: center;
    display: flex;
    flex-wrap: nowrap;
    min-width: 0;
}



.ganamos-header__navigation {
    flex: 1 1 auto;
    min-width: 0;
    overflow: visible;
}

.ganamos-header__navigation-list {
    align-items: center;
    gap: clamp(12px, 2vw, 48px);
    min-width: 0;
    width: 100%;
}

.ganamos-header__navigation-item,
.ganamos-header__navigation-action,
.ganamos-header__navigation-overflow {
    flex: 0 0 auto;
    margin-right: 0 !important;
}

.ganamos-header__navigation-overflow-toggle {
    display: flex;
    align-items: center;
    gap: 4px;
    border: 0;
    background: transparent;
}

.ganamos-header__navigation-overflow-chevron {
    font-size: 8px;
}

.ganamos-header__navigation-overflow-menu {
    min-width: 160px;
}

.ganamos-header__navigation-overflow-item {
  width: 100%;
  margin-left: 0;
  text-align: left;
}

.ganamos-header__navigation-item--gamanza,
.ganamos-header__navigation-overflow-item--gamanza {
    text-transform: uppercase;
}

.ganamos-header__actions {
    align-items: center;
    flex: 0 0 auto;
    gap: 20px;
    justify-content: flex-end;
    min-width: 0;
}

.ganamos-header__balance {
    width: auto;
}

.ganamos-header__user-actions {
    flex-wrap: nowrap;
}

@media (max-width: 1300px) {
    .ganamos-header__layout {
        padding-left: 12px;
        padding-right: 12px;
    }

    .ganamos-header__menu-toggle {
        margin-right: 8px !important;
    }

    .ganamos-header__navigation-list {
        gap: 12px;
    }

    .ganamos-header__navigation-item > div {
        font-size: .8rem;
        padding-left: 4px !important;
        padding-right: 4px !important;
    }

    .ganamos-header__navigation-action {
        padding-left: 4px !important;
        padding-right: 4px !important;
    }

    .ganamos-header__actions {
        gap: 8px;
    }

    .ganamos-header__support {
        padding-left: 4px;
        padding-right: 4px;
    }

    .ganamos-header__support img {
        height: 38px;
        width: 38px;
    }

    .ganamos-header__register-button {
        min-width: 96px !important;
    }

    .ganamos-header__login-button {
        min-width: 84px !important;
    }

    .ganamos-header__user-actions {
        gap: 4px !important;
        margin-right: 0 !important;
        padding-left: 4px !important;
        padding-right: 4px !important;
    }

    .header-desktop__separator {
        margin-left: 8px !important;
        margin-right: 8px !important;
    }
}

.header-desktop__separator {
    width: .125rem;
    height: 1.625rem;
    background: rgba(104, 41, 132, .5);
    margin: 0 1.25rem;
}

#notify-root {
    top: 2.5rem;
    position: fixed;
    width: 18rem;
    right: 2rem;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    z-index: 1201;
    margin: auto;
    -webkit-box-orient: vertical;
    -webkit-box-direction: reverse;
    -ms-flex-direction: column-reverse;
    flex-direction: column-reverse;
}

.notification_type_error {
    border-radius: .313rem;
    background-repeat: no-repeat;
    background-position-y: center;
    background-position-x: 1rem;
    background-size: 1.25rem;
}

.notification__wrapper {
    -webkit-box-flex: 2;
    -ms-flex-positive: 2;
    flex-grow: 2;
    width: 100%;
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}

.notification__text {
    -webkit-box-flex: 2;
    -ms-flex-positive: 2;
    flex-grow: 2;
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-left: 1rem;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    text-align: left;
    word-break: break-word;
    font-size: .875rem;
    -ms-flex-item-align: center;
    align-self: center;
}

.notification {
    width: 100%;
    min-height: 3.25rem;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    z-index: 100;
    margin-top: 1rem;
    color: #fff;
    padding: 0 1rem;
    font-size: .875rem;
    font-weight: 700;
    -webkit-animation: .7s ease init;
    animation: .7s ease init;
    position: relative;
    -webkit-box-shadow: 5px 5px 10px rgba(0, 0, 0, .5);
    box-shadow: 5px 5px 10px rgba(0, 0, 0, .5);
}
</style>
